/**
 * ListSearchInput – Search input usado en listados (facilities, locations, users).
 * Mismo estilo: borde gris, icono lupa, texto 18px, placeholder gris.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Search } from 'lucide-react';

const WRAPPER_CLASS =
  'bg-white border border-[#d3d6dc] rounded-[10px] h-[37px] pl-[7px] pr-7 flex items-center gap-[10px]';
const INPUT_CLASS =
  "font-['Roboto:Regular',sans-serif] font-normal text-[18px] text-[#6e6e71] bg-transparent border-none outline-none w-full placeholder:text-[#6e6e71]";

const ListSearchInput = ({
  value,
  onChange,
  placeholder = 'Search',
  ariaLabel,
  className = '',
  inputClassName = '',
}) => (
  <div className={`${WRAPPER_CLASS} ${className}`.trim()}>
    <Search className="w-6 h-6 text-[#6e6e71] shrink-0" aria-hidden />
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`${INPUT_CLASS} ${inputClassName}`.trim()}
      style={{ fontVariationSettings: "'wdth' 100" }}
      aria-label={ariaLabel ?? placeholder}
    />
  </div>
);

ListSearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
};

export default ListSearchInput;
